// extracted by mini-css-extract-plugin
module.exports = {"image":"sb-image_image__u1Rkx","blok-big-title":"sb-image_blok-big-title__Ohwzs","blok-title":"sb-image_blok-title__Qpjl_","blok-subtitle":"sb-image_blok-subtitle__Xpo3r"};